import React from 'react';
import PropTypes from 'prop-types';
import { StyledLink } from './styles';

const Link = ({
  children, onClick, className,
}) => (
  <StyledLink className={className} onClick={onClick}>
    {children}
  </StyledLink>
);

Link.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

Link.defaultProps = {
  className: null,
};

export default Link;
